import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useUserRole } from '@/hooks/useUserRole';

interface CIStatus {
  id: string;
  status: 'success' | 'failure' | 'running';
  commit_sha: string;
  commit_message: string | null;
  branch_name: string;
  workflow_url: string | null;
  failure_stage?: string | null;
  failure_details?: {
    failed_tests?: number;
    total_tests?: number;
  } | null;
  completed_at: string;
}

export function useCIStatus() {
  const { canAccessAdminPanel } = useUserRole();
  
  return useQuery({
    queryKey: ['ci-status'],
    queryFn: async () => {
      if (!canAccessAdminPanel) return null;
      
      const { data, error } = await supabase
        .from('ci_status')
        .select('*')
        .order('completed_at', { ascending: false })
        .limit(1)
        .maybeSingle();
      
      if (error) throw error;
      return data as CIStatus | null;
    },
    enabled: canAccessAdminPanel,
    refetchInterval: 30000, // Poll a cada 30s
    staleTime: 10000
  });
}
